// extracted by mini-css-extract-plugin
module.exports = {"root":"root_36UVL_OkqY"};